import { supabase } from "@/integrations/supabase/client";

/**
 * Notify the feedback-webhook edge function after a batch is submitted.
 * Fire & forget — does not block the UX if the webhook fails.
 */
export const notifyFeedbackWebhook = async (batchId: string) => {
  try {
    const { error } = await supabase.functions.invoke('feedback-webhook', {
      body: { batch_id: batchId },
    });
    if (error) {
      console.error('[feedback-webhook] Error:', error);
    }
  } catch (error) {
    console.error('[feedback-webhook] Error:', error);
  }
};
